import React from "react";
import "./food.css";

function Food() {
  return (
    <>
      <div className="content">
        <div className="food-1">
          <h3>Food varieties of India</h3>
          <p>
            {" "}
            Indian cuisine consists of a variety of regional and traditional
            cuisines native to the Indian subcontinent. Given the diversity in
            soil, climate, culture, ethnic groups, and occupations, these
            cuisines vary substantially and use locally available spices, herbs,
            vegetables, and fruits. Indian food is also heavily influenced by
            religion, in particular Hinduism, cultural choices and traditions.
            The cuisine is also influenced by centuries of Islamic rule,
            particularly the Mughal rule. Samosas and pilafs are examples.
            Historical events such as invasions, trade relations, and
            colonialism have played a role in introducing certain foods to this
            country. The Columbian discovery of the New World brought a number
            of new vegetables and fruit to India. A number of these such as the
            potato, tomatoes, chillies, peanuts, and Guava have become staples
            in many regions of India. Indian cuisine has shaped the history of
            international relations; the spice trade between India and Europe
            was the primary catalyst for Europe's Age of Discovery. Spices were
            bought from India and traded around Europe and Asia. Indian cuisine
            has influenced other cuisines across the world, especially those
            from Europe (especially Britain), the Middle East, Southern African,
            East Africa, Southeast Asia, North America, Mauritius, Fiji,
            Oceania, and the Caribbean
            
          </p>
          <img src="https://cdn.vox-cdn.com/thumbor/aNM9cSJCkTc4-RK1avHURrKBOjU=/1400x1400/filters:format(jpeg)/cdn.vox-cdn.com/uploads/chorus_asset/file/20059022/shutterstock_1435374326.jpg" />
        </div>
        <div className="dishes">
          <h1> Indian Food varities with respective states </h1>

          <div className="cardblock-2">
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/makki-de-roti.jpg" />
              <h4> Punjab: Makki Di Roti & Sarson Da Saag</h4>
            </div>
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/misal-pav.jpg" />
              <h4> Maharashtra: Misal Pav</h4>
            </div>
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/dhokla.jpg" />
              <h4> Gujarat: Dhokla </h4>
            </div>
            <div className="card_category_2">
              <img src="https://images.herzindagi.info/image/2019/May/tunday-kabab.jpg" />
              <h4> Uttar Pradesh: Tunde Ke Kebabs </h4>
            </div>
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/litti-chowkha.jpg" />
              <h4> Bihar: Litti Chowkha </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.merisaheli.com/wp-content/uploads/2018/01/bhutte-ki-kees.jpg" />
              <h4> Madhya Pradesh: Bhutte Ka Kees </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/dal-baati-churma.jpg" />
              <h4> Rajasthan: Dal Batti Churma </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/kosha-mangsho_5d3036c936254.jpg" />
              <h4> West Bengal: Kosha Mangsho </h4>
            </div>
          
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/rogan-josh_5d3037b27b7b4.jpg" />
              <h4> Kashmir: Rogan Josh </h4>
            </div>
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/pongal.jpg" />
              <h4> Tamilnadu: Pongal </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/papaya-khar.jpg" />
              <h4> Assam: Papaya Khar </h4>
            </div>{" "}
           
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/biryani.jpg" />
              <h4>Telangana: Biryani </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/fish-curry.jpg" />
              <h4> Goa: Fish curry </h4>
            </div>{" "}
          
     
            <div className="card_category_2">
              <img src="https://static.toiimg.com/thumb/53175707.cms?imgsize=175984&width=800&height=800" />
              <h4> Jharkhand: Dhooska </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/chila.jpg" />
              <h4> Chattisgarh: Chilla</h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/chenna-poda.jpg" />
              <h4> Odisha: Chenna Poda </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/misa-mach-poora.jpg" />
              <h4> Mizoram: Misa Mach Poora </h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.indianhealthyrecipes.com/wp-content/uploads/2021/07/bisi-bele-bath-recipe.jpg" />
              <h4> Karnataka: Bisi Bele Bhat</h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/thukpa.jpg" />
              <h4> Arunachal Pradesh: Thukpa</h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.outlookindia.com/outlooktraveller/public/uploads/filemanager/images/appam.jpg" />
              <h4> Kerela: Appam</h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://i0.wp.com/evergreendishes.com/wp-content/uploads/2020/01/kafuli-1-scaled.jpg?fit=2560%2C1707&ssl=1" />
              <h4> Uttarakhand: Kafuli</h4>
            </div>{" "}
            <div className="card_category_2">
              <img src="https://www.sitarafoods.com/images/Sitara/image-Bellam_Putharekulu_Long-1590734841178.jpg" />
              <h4> Andhra Pradesh: Pootharekulu</h4>
            </div>{" "}
            
          
          </div>
        </div>
      </div>
    </>
  );
}

export default Food;
